import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ChevronLeft, ChevronRight } from 'lucide-react';
import { sectionHook } from '../../lib/domHooks';

/**
 * Betrun şemasının bölüm kabuğu: sol üstte başlık (varsa "tümünü gör" oku),
 * sağ üstte şeridi kaydıran ok çifti, altında yatay kayan kart şeridi.
 */
const BetrunSection = ({
  title, to, wide = false, stripClass = '', section, children,
}) => {
  const stripRef = useRef(null);

  const scroll = (direction) => {
    const el = stripRef.current;
    if (!el) return;
    el.scrollBy({ left: direction * Math.max(el.clientWidth * 0.8, 240), behavior: 'smooth' });
  };

  return (
    <section {...sectionHook(section)}>
      <div className="betrun-section-head">
        <h2 className="betrun-section-title">
          {title}
          {to && (
            <Link to={to} className="betrun-section-more" aria-label={`${title} — tümünü gör`}>
              <ArrowUpRight size={13} />
            </Link>
          )}
        </h2>
        <div className="betrun-section-nav">
          <button
            type="button"
            className="betrun-subnav-arrow"
            onClick={() => scroll(-1)}
            aria-label="Önceki"
          >
            <ChevronLeft size={14} />
          </button>
          <button
            type="button"
            className="betrun-subnav-arrow"
            onClick={() => scroll(1)}
            aria-label="Sonraki"
          >
            <ChevronRight size={14} />
          </button>
        </div>
      </div>
      <div className={`betrun-strip ${wide ? 'is-wide' : ''} ${stripClass}`.trim()} ref={stripRef}>
        {children}
      </div>
    </section>
  );
};

export default BetrunSection;
